import React, { useEffect, useState, useRef, useCallback } from "react";

import { FontIcon, DefaultButton, PrimaryButton } from "@fluentui/react";
import { useDropzone } from "react-dropzone";
import Webcam from "react-webcam";

import SofIcon from "../../common/Icons";

const videoConstraints = {
  width: 698,
  height: 523,
  facingMode: "user",
};

interface IProps {
  displayPreview?: boolean;
  isUploading: boolean;
  requiredState?: boolean;
  hasError: boolean;
  files: any[];
  setFiles: (data: any) => void;
  multipleUpload?: boolean;
}

const PictureAndUpload = ({
  displayPreview = true,
  requiredState = false,
  isUploading,
  hasError,
  files,
  setFiles,
  multipleUpload = false,
}: IProps) => {
  const webcamRef = useRef<any>(null);
  const [showCamera, setShowCamera] = useState(false);

  const { getRootProps, getInputProps, open, acceptedFiles } = useDropzone({
    accept: {
      "image/*": [],
    },
    multiple: multipleUpload,
    noClick: true,
    noKeyboard: true,
  });

  useEffect(() => {
    if (acceptedFiles?.length > 0) {
      if (multipleUpload) {
        acceptedFiles.forEach((file: any) => {
          let reader = new FileReader();

          reader.readAsDataURL(file);
          reader.onload = async () => {
            const base64String = reader.result;
            const dataFile = Object.assign(file, {
              preview: base64String,
              canDelete: true,
              fileSize: file.size,
              fileName: file.name,
            });
            setFiles((prev: any) => [...prev, dataFile]);
          };
        });

        // acceptedFiles.map(file => {

        // })
      } else {
        setFiles(
          acceptedFiles.map((file) =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
            })
          )
        );
      }
    }
  }, [acceptedFiles]);

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    const uuidv4 = new Date();
    const name = uuidv4.toString();
    if (multipleUpload) {
      setFiles((prev: any) => [
        ...prev,
        {
          name: `${name}.jpg`,
          fileName: `${name}.jpg`,
          preview: imageSrc,
          fileSize: 0,
          canDelete: true,
          type: "image/jpeg",
        },
      ]);
    } else {
      setFiles([
        {
          name: `${name}.jpg`,
          fileName: `${name}.jpg`,
          preview: imageSrc,
          type: "image/jpeg",
        },
      ]);
    }
    setShowCamera(false);
  }, [webcamRef]);

  return (
    <>
      <div className={`upload-wrapper ${requiredState ? "has-error" : ""}`}>
        {showCamera ? (
          <div className="webcam-wrapper">
            <button onClick={() => setShowCamera(false)} className="btn-cancel">
              <FontIcon iconName="cancel" />
            </button>
            <button
              onClick={capture}
              disabled={isUploading}
              className="webcam-btn"
            >
              <svg
                width="56"
                height="55"
                viewBox="0 0 56 55"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="28"
                  cy="27.5"
                  r="25"
                  stroke="white"
                  stroke-width="5"
                />
              </svg>
            </button>

            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              videoConstraints={videoConstraints}
              minScreenshotWidth={180}
              minScreenshotHeight={180}
            />
            <span className="border_bottom"></span>
          </div>
        ) : files.length === 0 || !displayPreview ? (
          <div {...getRootProps({ className: "dropzone" })}>
            <input {...getInputProps()} />
            <div className="upload-inner">
              <SofIcon iconname="ImgPlaceholder" />
              <p>Attach an image of the issue</p>
              <PrimaryButton
                type="submit"
                className="action-button-submit"
                disabled={isUploading}
                onClick={() => setShowCamera(true)}
              >
                Take picture of issue
              </PrimaryButton>
              <p className="separator">- or -</p>
              <DefaultButton
                onClick={open}
                className="action-button-submit"
                disabled={isUploading}
              >
                Upload picture
              </DefaultButton>
            </div>
          </div>
        ) : (
          <div className="images-wrapper">
            <button
              disabled={isUploading}
              onClick={() => {
                setFiles([]);
              }}
              className="btn-close"
            >
              <FontIcon iconName="cancel" />
            </button>
            <img
              src={files[0].preview}
              onLoad={() => {
                URL.revokeObjectURL(files[0].preview);
              }}
            />
          </div>
        )}
      </div>
      {hasError && (
        <p className="error-upload error-txt">
          Error on uploading image or photo.
        </p>
      )}
    </>
  );
};

export default PictureAndUpload;
